import { IState } from '../../store';

export function getRegularInfrastructure(state: IState) {
  return state.newbuildingInfrastructure.regularInfrastructureItems;
}
